import Logo from '../logos/bdrsim';

export default Logo;
